import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import chunk from 'lodash/chunk';
import ImageList from '@fuww/library/src/ImageList';

import variables from '../../../../lib/queries/lookbook/variables/images';
import Item from './Item';

const { first: perPage } = variables;

const ImageListGrid = ({
  edges,
  ItemComponent,
  onSelect,
  route,
  preloadFirst,
}) => {
  const [cols, setCols] = useState(1);
  const [maxWidthReached, setMaxWidthReached] = useState(false);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 1440) {
        setMaxWidthReached(true);
      } else {
        setMaxWidthReached(false);
      }

      if (window.innerWidth >= 858) {
        return setCols(4);
      }

      if (window.innerWidth >= 498) {
        return setCols(3);
      }

      return setCols(1);
    };

    window.addEventListener('resize', onResize);

    onResize();

    return () => {
      window.removeEventListener('resize', onResize);
    };
  });

  const width = maxWidthReached ? '352px' : `calc(${100 / cols}vw - 16px)`;

  return chunk(edges, perPage).map((edgesPerPage, chunkIndex) => (
    <ImageList
      // eslint-disable-next-line react/no-array-index-key
      key={chunkIndex}
      variant="masonry"
      gap={8}
      cols={cols}
    >
      {edgesPerPage.map(({ node }, index) => {
        const isFirstImage = chunkIndex === 0 && index === 0;
        const fetchPriority = preloadFirst && isFirstImage ? 'high' : 'low';

        return (
          <ItemComponent
            {...node}
            key={node.id}
            width={width}
            onSelect={onSelect}
            route={
            ['lookbook', 'lookbookCategory'].includes(route)
              ? 'lookbookImage'
              : 'dashboardImage'
          }
            preload={preloadFirst && isFirstImage}
            finalFetchpriority={fetchPriority}
            placeholderFetchpriority={fetchPriority}
          />
        );
      })}
    </ImageList>
  ));
};

ImageListGrid.propTypes = {
  images: PropTypes.shape({}),
  ItemComponent: PropTypes.elementType,
  onSelect: PropTypes.func,
  route: PropTypes.string,
  preloadFirst: PropTypes.bool,
};

ImageListGrid.defaultProps = {
  images: {
    edges: [],
  },
  ItemComponent: Item,
  onSelect: undefined,
  route: undefined,
  preloadFirst: false,
};

export default ImageListGrid;
